import { AgResourceLanguage } from '../types';
import { cart as EnUsCart } from '../en-us/cart';

export const cart: AgResourceLanguage['cart'] = {
  ...EnUsCart,
  subscriptionTitle: 'Abonnement',
  oneTimeTitle: 'Eenmalige Aankoop',
  giftCartTitle: 'Cadeaubestelling',
  oneTimeDescription: 'Deze artikelen worden geleverd met je eerste abonnementsbestelling:',
  oneTimeCarouselTitle: 'Dit Vindt Je Misschien Ook Leuk',
  clearCartText: 'Verwijder Producten',
  oneTimeCarouselAddButton: 'Toevoegen',
  title: 'Je Winkelwagen',
  checkoutButtonLabel: 'Afrekenen',
  emptyState: {
    oneTimeProductsTitle: 'Favorieten van Leden',
    addOneTimeProductButton: 'Toevoegen aan Winkelwagen',
    label: 'Voeg artikelen toe aan je winkelwagen'
  },
  emptyStateLabel: 'Voeg artikelen toe aan je winkelwagen',
  frequencyLabel: 'Wordt elke 30 dagen verzonden:',
  deliveryInfo:
    'Wanneer je de betaling voltooit, wordt je bestelling binnen 24 uur M-V na betaling verzonden. Houd rekening met maximaal 48 uur in het weekend en op feestdagen.',
  deleteItemModal: {
    title: 'Verwijder Artikelen Uit Winkelwagen',
    description: 'Weet je zeker dat je artikelen uit je winkelwagen wilt verwijderen?'
  },
  clearCartModal: {
    title: 'Verwijder Alle Artikelen Uit Winkelwagen',
    description: 'Weet je zeker dat je alle artikelen uit je winkelwagen wilt verwijderen?'
  },
  free: 'Gratis',
  scoopPrompt: 'Heb je een schepje nodig bij je zak? Voeg het hieronder gratis toe.'
};
